import React from "react";
import { Button, ButtonGroup } from "reactstrap";
import { useSearchQuery } from "hooks";

const FilterToggle = () => {
  const [{ isAdvanced }, setQuery] = useSearchQuery();
  const toggleSelected = (value) => setQuery({ isAdvanced: !isAdvanced });

  return (
    <ButtonGroup>
      <Button onClick={toggleSelected} active={!isAdvanced} size="sm">
        Basic
      </Button>
      <Button onClick={toggleSelected} active={isAdvanced} size="sm">
        Advanced
      </Button>
    </ButtonGroup>
  );
};

export { FilterToggle };
